import { Link } from 'react-router-dom';
import { Button } from 'src/components/Button';
import { Checkbox } from 'src/components/Form/Checkbox';
import { InputEmail } from 'src/components/Form/Email';
import { MultiSelect } from 'src/components/Form/MultiSelect';
import { InputPassword } from 'src/components/Form/Password';
import { InputPhone } from 'src/components/Form/Phone';
import { Select } from 'src/components/Form/Select';
import { InputText } from 'src/components/Form/Text';
import { Icon } from 'src/components/Icon';
import { Form } from 'src/form';
import { AuthLayout } from 'src/layouts';

import styles from './styles.module.css';

export const DevelopmentPreview = () => {
  return (
    <AuthLayout>
      <Form initialValues={{}} onSubmit={() => {}}>
        <ul className={styles.ul}>
          <li className={styles.li}>
            <Icon name="check" />
          </li>
          <li className={styles.li}>
            <InputEmail name="email" label="Email" placeholder="Email" />
          </li>
          <li className={styles.li}>
            <InputPhone name="phone" label="Phone" placeholder="Phone" />
          </li>
          <li className={styles.li}>
            <InputText
              name="first_name"
              label="First Name"
              placeholder="First Name"
            />
          </li>
          <li className={styles.li}>
            <InputText
              name="last_name"
              label="Last Name"
              placeholder="Last Name"
            />
          </li>
          <li className={styles.li}>
            <InputPassword
              name="password"
              label="Password"
              placeholder="Password"
            />
          </li>
          <li className={styles.li}>
            <InputPassword
              name="confirm_password"
              label="Confirm Password"
              placeholder="Confirm Password"
            />
          </li>
          <li className={styles.li}>
            <Select
              name="active_game"
              label="Active Game"
              placeholder="Select"
              data={[
                { label: 'GAME1', value: '1' },
                { label: 'GAME1', value: '2' },
                { label: 'GAME1', value: '3' },
                { label: 'GAME1', value: '4' },
                { label: 'GAME1', value: '5' },
                { label: 'GAME1', value: '6' },
                { label: 'GAME1', value: '7' },
                { label: 'GAME1', value: '8' },
              ]}
            />
          </li>
          <li className={styles.li}>
            <MultiSelect
              name="active_game"
              label="Active Game"
              required
              placeholder="Select"
              data={[
                { label: 'GAME1', value: '1' },
                { label: 'GAME2', value: '2' },
                { label: 'GAME3', value: '3' },
                { label: 'GAME4', value: '4' },
                { label: 'GAME5', value: '5' },
                { label: 'GAME6', value: '6' },
                { label: 'GAME7', value: '7' },
                { label: 'GAME8', value: '8' },
                { label: 'GAME9', value: '9' },
                { label: 'GAME10', value: '10' },
                { label: 'GAME11', value: '11' },
                { label: 'GAME12', value: '12' },
                { label: 'GAME13', value: '13' },
                { label: 'GAME14', value: '14' },
                { label: 'GAME15', value: '15' },
                { label: 'GAME16', value: '16' },
              ]}
              withSearch
            />
          </li>
          <li className={styles.li}>
            <Checkbox
              name="consent"
              label={
                <span>
                  I agree to the <Link to="/">Terms</Link> and{' '}
                  <Link to="/">Conditions</Link> and{' '}
                  <Link to="/">Privacy Policy</Link>.
                </span>
              }
            />
          </li>
          <li className={styles.li}>
            <Button variant="filled">FILLED</Button>
          </li>
          <li className={styles.li}>
            <Button round variant="filled">
              ROUND FILLED
            </Button>
          </li>

          <li className={styles.li}>
            <Button variant="filled" disabled>
              DISABLED FILLED
            </Button>
          </li>

          <li className={styles.li}>
            <Button variant="filled" loading>
              FILLED LOADING
            </Button>
          </li>
          <li className={styles.li}>
            <Button variant="outline">OUTLINE</Button>
          </li>
          <li className={styles.li}>
            <Button variant="outline" round>
              ROUND OUTLINE
            </Button>
          </li>
          <li className={styles.li}>
            <Button variant="outline" disabled>
              DISABLED OUTLINE
            </Button>
          </li>
          <li className={styles.li}>
            <Button variant="outline" loading>
              LOADER OUTLINE
            </Button>
          </li>
          <li className={styles.li}>
            <Button variant="transparent">TRANSPARENT</Button>
          </li>
          <li className={styles.li}>
            <Button variant="transparent" disabled>
              DISABLED TRANSPARENT
            </Button>
          </li>

          <li className={styles.li}>
            <Button variant="transparent" loading>
              LOADER TRANSPARENT
            </Button>
          </li>
        </ul>
      </Form>
    </AuthLayout>
  );
};
